import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { InputRange } from 'components/UI';
import { Tooltip } from 'antd';
import _ from 'lodash';
import cn from 'classnames';
import { attributeNumberRange as AttributeNumberRange } from 'theme/icon';
import styles from './styles.scss';

const getInitialValue = values => {
  let newValue = _.cloneDeep(values);
  newValue = newValue || {};
  newValue.value = newValue.value || {};
  newValue.value.from = typeof newValue.value.from === 'string' ? newValue.value.from : null;
  newValue.value.to = typeof newValue.value.to === 'string' ? newValue.value.to : null;
  return newValue;
};

const NumberRangeAttribute = props => {
  const [value, setValue] = useState(getInitialValue(props.value));
  const { isEditable } = props;
  const getFormattedValue = val => {
    const number = +parseFloat(val.toString().replace(',', '.')).toFixed(2);
    return number.toString().replace('.', ',');
  };
  useEffect(() => {
    setValue(getInitialValue(props.value));
  }, [props.value]);
  return (
    <div className={cn(styles.row, styles.numberRange)}>
      <div className={styles.header}>
        <div className={styles.icon}>
          <AttributeNumberRange alt="" />
        </div>
        <div className={styles.caption}>
          <Tooltip placement="bottomLeft" title={props.name.length > 25 ? props.name : null}>
            <h4>{_.truncate(props.name, { omission: '...', length: 25 })}</h4>
          </Tooltip>
        </div>
      </div>
      <div className={styles.body}>
        {isEditable ? (
          <React.Fragment>
            <InputRange
              errors={props.meta.error}
              value={{ from: value.from, to: value.to }}
              isNegativeNumber
              onChange={val => {
                const reg = /^(\d*(\s{1})?\d+?)+([/.,]{1})?(\d+)?$/;
                const newValue = _.cloneDeep(value);
                if ((val.from && reg.test(val.from) && val.from.length <= 15) || !val.from) {
                  newValue.from = val.from ? val.from.toString().replace(',', '.').replace(/\s+/g, '') : null;
                }

                if ((val.to && reg.test(val.to) && val.to.length <= 15) || !val.from) {
                  newValue.to = val.to ? val.to.toString().replace(',', '.').replace(/\s+/g, '') : null;
                }

                setValue(newValue);
                props.onChange(newValue);
              }}
            />
            {props.meta.error && props.meta.error.to && (
              <span className={styles.error}>Второе значение не может быть меньше первого</span>
            )}
          </React.Fragment>
        ) : (
          <React.Fragment>
            {props.value && (props.value.from || props.value.to) && (
              <span>
                {props.value.from ? `${getFormattedValue(props.value.from)} - ` : 'Нет данных - '}
                {props.value.to ? getFormattedValue(props.value.to) : 'Нет данных'}
              </span>
            )}
          </React.Fragment>
        )}
      </div>
    </div>
  );
};

NumberRangeAttribute.propTypes = {
  meta: PropTypes.objectOf(PropTypes.any).isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.objectOf(PropTypes.any),
  isEditable: PropTypes.objectOf(PropTypes.bool).isRequired,
};

NumberRangeAttribute.defaultProps = {
  value: null,
};

export default NumberRangeAttribute;
